module.exports = __webpack_public_path__ + "img/trxkrw.3a29ad76.png";